import React from "react";
import { useSearchParams } from "react-router-dom";

const DocumentViewer = ({user}) => {
const height="900px";

    const getViewerUrl = () => {
        const [searchParams] = useSearchParams();
        const googleId = searchParams.get("googleid");
        const type = searchParams.get("type");
        

        switch(type){

            case "pdf":
                //https://drive.google.com/file/d/1pXYSeKlJ0Y7qCKppHCON092-Gt3b2ApZ/view
                //https://drive.google.com/file/d/1yzGf0c73Nyk1It15YUG9Y0naaWNruBOb/view?usp=drive_link
                console.log(`https://drive.google.com/file/d/${googleId}/preview`);
                return `https://drive.google.com/file/d/${googleId}/preview`;

            case "google-doc":
                const gdocurl=`https://docs.google.com/document/d/${googleId}/edit`;
                return gdocurl.replace("/edit","/preview");

            case "google-drive":
                return `https://drive.google.com/file/d/${googleId}/preview`;

            case "word":
                const url=`https://docs.google.com/document/d/${googleId}/edit?usp=sharing&ouid=108491912398792947894&rtpof=true&sd=true`;
                return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`;

            default:
                return url;
        }

    };

    return (

        <div
            style={{
                width:"100%",
                height:height,
                border:"1px solid #ddd",
                borderRadius:"8px",
                overflow:"hidden"
            }}
        >

            <iframe
                title="Document Viewer"
                src={getViewerUrl()}
                width="100%"
                height="100%"
                frameBorder="0"
            />

        </div>

    );

};

export default DocumentViewer;